export const tableStyleCompact = {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '12px',
    background: '#fff',
    marginTop: '24px',
};

export const thStyleCompact = {
    border: '1px solid #ccc',
    padding: '0px 2px',
    textAlign: 'center',
};

export const tdStyleCompact = {
    border: '1px solid #ccc',
    padding: '0px 2px',
    textAlign: 'left',
};

export const sectionTitleStyle = {
    textAlign: 'left',
    margin: '12px 0 0 0',
    fontWeight: 'bold',
    fontSize: '0.8em',
};
